"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectUrlToAttributes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const analytics_next_1 = require("@atlaskit/analytics-next");
const analytics_bridge_1 = require("@atlassian/analytics-bridge");
const analytics_1 = require("../utils/analytics");
const package_json_1 = require("../../package.json");
function getEnv() {
    // We require this so it is lazily instantiated (doesn't run on SSR!)
    const { envType } = require('@atlassiansox/analytics-web-client');
    const defaultEnvironment = envType.LOCAL;
    return (envType[process.env.GATSBY_CONSTELLATION_ENVIRONMENT] || defaultEnvironment);
}
function getLang() {
    if (typeof navigator === 'undefined') {
        return;
    }
    if (navigator.languages !== undefined) {
        return navigator.languages[0];
    }
    else {
        return navigator.language;
    }
}
function getUrlData() {
    if (typeof location === 'undefined') {
        return undefined;
    }
    return {
        url: location.href,
    };
}
function injectUrlToAttributes(payload) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...getUrlData(),
        },
    };
}
exports.injectUrlToAttributes = injectUrlToAttributes;
function AnalyticsProvider({ children, }) {
    const client = react_1.useRef(null);
    const onAnalyticEventFired = react_1.useCallback((event) => {
        if (!client.current) {
            client.current = analytics_1.createAnalyticsClient({
                version: package_json_1.version,
                product: 'designSystemDocs',
                env: getEnv(),
                locale: getLang(),
                useLegacyUrl: true,
            });
            client.current.startUIViewedEvent();
        }
        let { type, payload } = analytics_bridge_1.extractAWCDataFromEvent(event);
        payload = injectUrlToAttributes(payload);
        switch (type) {
            case analytics_bridge_1.UI_EVENT_TYPE:
                client.current.sendUIEvent(payload);
                break;
            case analytics_bridge_1.TRACK_EVENT_TYPE:
                client.current.sendTrackEvent(payload);
                break;
            case analytics_bridge_1.OPERATIONAL_EVENT_TYPE:
                client.current.sendOperationalEvent(payload);
                break;
            case analytics_bridge_1.SCREEN_EVENT_TYPE:
                client.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return (jsx_runtime_1.jsx(analytics_next_1.AnalyticsListener, Object.assign({ channel: analytics_bridge_1.ANALYTICS_BRIDGE_CHANNEL, onEvent: onAnalyticEventFired }, { children: jsx_runtime_1.jsx(analytics_bridge_1.ContextualAnalyticsData, { children: children }, void 0) }), void 0));
}
exports.default = AnalyticsProvider;
